import {
  HasSlotController
} from "./chunk.SR35WVC6.js";
import {
  size_default
} from "./chunk.SI24X5IH.js";
import {
  appearance_default
} from "./chunk.GO6CI477.js";
import {
  WebAwesomeElement,
  n,
  t
} from "./chunk.LVUMIIKQ.js";
import {
  ke
} from "./chunk.S3625EU6.js";
import {
  __decorateClass
} from "./chunk.SZE6ONST.js";

// src/components/card/card.css
var card_default = ":host {\n  --space-s: var(--wa-space-l);\n  --space-m: var(--wa-space-xl);\n  --space-l: var(--wa-space-2xl);\n\n  --spacing: var(--wa-space);\n  --border-width: var(--wa-panel-border-width);\n  --outlined-background-color: var(--wa-color-surface-default);\n  --outlined-border-color: var(--wa-color-surface-border);\n  --border-radius: var(--wa-panel-border-radius);\n  --inner-border-radius: calc(var(--border-radius) - var(--border-width));\n  --inner-border-color: var(--outlined-border-color);\n\n  display: flex;\n  flex-direction: column;\n  background-color: var(--background-color, var(--wa-color-surface-default));\n  border-color: var(--border-color, var(--wa-color-surface-border));\n  border-radius: var(--border-radius);\n  border-style: var(--wa-panel-border-style);\n  box-shadow: var(--wa-shadow-s);\n  border-width: var(--border-width);\n  color: var(--wa-color-text-normal);\n}\n\n:host(:is([appearance~='accent'], .wa-accent)) {\n  color: var(--text-color, var(--wa-color-text-normal));\n}\n\n:host([appearance~='filled']),\n:host(.wa-filled) {\n  --inner-border-color: oklab(from var(--outlined-border-color) l a b / 65%);\n}\n\n:host([appearance='plain']) {\n  --inner-border-color: transparent;\n  box-shadow: none;\n}\n\n/* Take care of top and bottom radii */\n.image,\n:host(:not([with-image])) .header,\n:host(:not([with-image], [with-header])) .body {\n  border-start-start-radius: var(--inner-border-radius);\n  border-start-end-radius: var(--inner-border-radius);\n}\n\n:host(:not([with-footer])) .body,\n.footer {\n  border-end-start-radius: var(--inner-border-radius);\n  border-end-end-radius: var(--inner-border-radius);\n}\n\n.image {\n  display: flex;\n\n  &::slotted(img) {\n    display: block;\n    width: 100%;\n    border-start-start-radius: inherit !important;\n    border-start-end-radius: inherit !important;\n  }\n}\n\n/* Round all corners for plain appearance */\n:host([appearance='plain']) .image {\n  border-radius: var(--inner-border-radius);\n\n  &::slotted(img) {\n    border-radius: inherit !important;\n  }\n}\n\n.header {\n  display: block;\n  border-block-end-style: inherit;\n  border-block-end-color: var(--inner-border-color);\n  border-block-end-width: var(--border-width);\n  padding: calc(var(--spacing) / 2) var(--spacing);\n}\n\n.body {\n  display: block;\n  padding: var(--spacing);\n}\n\n.footer {\n  display: block;\n  border-block-start-style: inherit;\n  border-block-start-color: var(--inner-border-color);\n  border-block-start-width: var(--border-width);\n  padding: var(--spacing);\n}\n\n:host(:not([with-header])) .header,\n:host(:not([with-footer])) .footer,\n:host(:not([with-image])) .image {\n  display: none;\n}\n";

// src/components/card/card.ts
var WaCard = class extends WebAwesomeElement {
  constructor() {
    super(...arguments);
    this.hasSlotController = new HasSlotController(this, "footer", "header", "image");
    this.size = "inherit";
    this.appearance = "outlined";
    this.withHeader = false;
    this.withImage = false;
    this.withFooter = false;
  }
  updated() {
    if (!this.withHeader && this.hasSlotController.test("header")) this.withHeader = true;
    if (!this.withImage && this.hasSlotController.test("image")) this.withImage = true;
    if (!this.withFooter && this.hasSlotController.test("footer")) this.withFooter = true;
  }
  render() {
    return ke`
      <slot name="image" part="image" class="image"></slot>
      <slot name="header" part="header" class="header"></slot>
      <slot part="body" class="body"></slot>
      <slot name="footer" part="footer" class="footer"></slot>
    `;
  }
};
WaCard.shadowStyle = [size_default, appearance_default, card_default];
__decorateClass([
  n({ reflect: true, initial: "medium" })
], WaCard.prototype, "size", 2);
__decorateClass([
  n({ reflect: true })
], WaCard.prototype, "appearance", 2);
__decorateClass([
  n({ attribute: "with-header", type: Boolean, reflect: true })
], WaCard.prototype, "withHeader", 2);
__decorateClass([
  n({ attribute: "with-image", type: Boolean, reflect: true })
], WaCard.prototype, "withImage", 2);
__decorateClass([
  n({ attribute: "with-footer", type: Boolean, reflect: true })
], WaCard.prototype, "withFooter", 2);
WaCard = __decorateClass([
  t("wa-card")
], WaCard);

export {
  WaCard
};
